module.exports = __webpack_public_path__ + "img/register-banner.816c96fa.png";